import {
  RocketIcon,
  DocumentsIcon,
  TargetIcon,
  PartnershipIcon,
  CelebrateIcon,
} from '@onbeam/icons/business';
import { BeamIcon } from '@onbeam/icons';
import { TimelineItem } from './TimelineItem/TimelineItem.types';

export const timelineItems: TimelineItem[] = [
  {
    icon: RocketIcon,
    title: 'Apply & share your idea',
    description:
      'Submit your project details, team, budget, milestones, and tell us how it will grow the Beam ecosystem.',
  },
  {
    icon: DocumentsIcon,
    title: 'We review & evaluate',
    description:
      'Our team checks your project for quality, team strength, budget sense, community impact, and fit with Beam’s goals.',
  },
  {
    icon: TargetIcon,
    title: 'Get a tailored grant plan',
    description:
      'If approved, we’ll build a milestone-based funding plan with flexible KPIs designed around your roadmap.',
  },
  {
    icon: PartnershipIcon,
    title: 'Sign & launch',
    description:
      'We finalize approvals, handle legal agreements, and lock in your funding structure.',
  },
  {
    icon: CelebrateIcon,
    title: 'Build & get funded',
    description:
      'Receive funding in stages as you hit milestones, with regular check-ins to keep things on track.',
  },
  {
    icon: BeamIcon,
    title: 'Grow with Beam',
    description:
      'Enjoy ecosystem support, technical help, co-marketing, and connections to future funding, so your project can truly thrive.',
  },
];
